import { OPEN_MODAL, CLOSE_MODAL } from '../constants';
import { Action } from '~/redux/types';

export type ModalAction = (payload: string) => Action;

export const openModal: ModalAction = (payload: string): Action => ({
  type: OPEN_MODAL,
  payload,
});

export const closeModal: ModalAction = (payload: string): Action => ({
  type: CLOSE_MODAL,
  payload,
});
